<template>
  <section class="examList">
    <h1 class="study-title">
      <img
        src="../../../assets/img/learningGuidePage/reporttest.png"
        alt=""
      /><span>考试</span>
    </h1>
    <div class="examBox">
      <div class="nameTheTest"><span>考试名称</span><span>成绩</span><span>排名</span></div>
      <ul>
        <li
          v-for="(item, index) in totalData"
          :key="index"
        >
          <span class="examName">{{ item.examName }}</span>
          <span>{{ item.score === -1||item.score===null? `--`:item.score }}</span>
          <span>{{ item.rank && item.rank !== -1 ? item.rank : `--` }}</span>
        </li>

      </ul>
      <div
        class="more"
        @click="getMoreBtn"
        v-show="brandFold"
      >
        更多<img
          src="../../../assets/img/learningGuidePage/reportmore.png"
          alt=""
        />
      </div>
    </div>

    <CommonLoading v-show="loading" />
  </section>
</template>
<script>
import { reqStudyExamInfo } from '@/api/learningGuidePage';
import CommonLoading from '@/components/commonComponents/CommonLoading.vue';

export default {
  components: {
    CommonLoading,
  },
  props: {
    studyExamList: {
      type: Object,
      default: () => { },
    },
  },
  data() {
    return {
      brandFold: true,
      pageNum: 1,
      totalData: [],
      FirstData: [],
      point: false, // 防连点
      loading: false,
    };
  },
  watch: {
    studyExamList: {
      handler(newVal) {
        if (newVal) {
          if (newVal.pages === 0 || newVal.pages === 1) {
            this.brandFold = false;
          }
          this.totalData = newVal.data;
        }
      },
      immediate: true,
    },
  },
  methods: {
    getMoreBtn() {
      this.loading = true;
      if (this.point) return;
      this.point = true;
      // eslint-disable-next-line no-plusplus
      this.pageNum++;
      this.getExamListInfo();
    },
    async getExamListInfo() {
      const { userProductId } = this.$route.query;
      const res = await reqStudyExamInfo(userProductId, this.pageNum, 10);
      if (res.code === 0 && res?.data?.examInfoVOS?.data?.length > 0) {
        const { examInfoVOS } = res?.data;
        this.FirstData = examInfoVOS.data;
        this.totalData = [...this.totalData, ...this.FirstData];
        if (examInfoVOS.pages === this.pageNum) {
          this.brandFold = false;
        }
      }
      this.loading = false;
      setTimeout(() => {
        this.point = false;
      }, 500);
    },
  },
  created() { },
  mounted() { },
};
</script>
<style scoped lang="scss">
.examList {
  width: 678px;
  background: #fff;
  box-shadow: 0px 4px 11px 0px rgba(0, 0, 0, 0.02);
  border-radius: 14px;
  margin: 0 auto;
  padding: 36px 33px;
  .study-title {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding-bottom: 42px;
    img {
      width: 29px;
      height: 29px;
    }
    span {
      font-size: 29px;
      font-weight: 500;
      color: #333333;
      line-height: 40px;
      padding-left: 5px;
    }
  }
  .examBox {
    .nameTheTest {
      display: flex;
      margin-bottom: 22px;
      span {
        display: block;
        font-size: 25px;
        font-weight: 400;
        color: #666;
        line-height: 36px;
        &:nth-of-type(1) {
          width: 69%;
        }
        &:nth-of-type(2) {
          width: 15%;
          text-align: center;
        }
        &:nth-of-type(3) {
          width: 16%;
          text-align: center;
        }
      }
    }
    ul {
      li {
        display: flex;
        padding: 22px 0;
        border-top: 1px solid #e8e8e8;
        span {
          display: block;
          font-size: 25px;
          font-weight: 500;
          color: #333333;
          &:nth-of-type(1) {
            width: 69%;
          }
          &:nth-of-type(2) {
            width: 15%;
            text-align: center;
          }
          &:nth-of-type(3) {
            width: 16%;
            text-align: center;
          }
        }
        .examName {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
    .more {
      width: 20%;
      font-size: 22px;
      font-weight: 400;
      color: #a5a5a5;
      line-height: 17px;
      display: flex;
      align-items: center;
      margin: 0 auto;
      cursor: pointer;
      img {
        width: 24px;
        height: 11px;
        margin-left: 5px;
      }
    }
  }
  ::v-deep .is-loading {
    width: 84%;
  }
}
</style>
